import { type Item } from '@/components/wrapped/ActionCard';

// Mock data for the site mockups, kept off the compositions so the pictures are
// arrangement and nothing else.
//
// Deliberately thinner than the app's own fixtures: a marketing frame shows two
// or three rows, and a linked call or a file list is detail the crop loses.

export const ACTIONS: Item[] = [
  {
    id: 1,
    title: 'Upload your mum’s bank statement',
    overdue: true,
    schedule: 'Due Friday',
    who: 'YB',
    createdBy: 'Yasmin',
    files: [],
    kind: 'cam',
    done: false,
  },
  {
    id: 2,
    title: 'Pick up her prescription',
    schedule: 'Every Tuesday',
    who: 'VM',
    createdBy: 'Vez',
    files: [],
    kind: 'user',
    done: false,
  },
];

/**
 * The claims we help with. Matches ClaimRow's props.
 *
 * No answered counts. ClaimRow takes one and these used to carry it, but "31 of
 * 34 answered" says the form arrived part filled, which is the thing that is not
 * live yet. The claims themselves are what the care team does today.
 */
export const CLAIMS: {
  icon: string;
  name: string;
  description: string;
  lead?: boolean;
}[] = [
  {
    icon: 'hand-holding-heart',
    name: 'Attendance Allowance',
    description: 'Help with the cost of care at home',
    lead: true,
  },
  {
    icon: 'sterling-sign',
    name: 'Council Tax reduction',
    description: 'A discount on the bill',
  },
  {
    icon: 'file-contract',
    name: 'Pension Credit',
    description: 'Tops up a low weekly income',
  },
];
